import gsap from 'gsap';

const selectors = {
  el: '.js-push:not(.is-initialized)'
};

const mq = window.matchMedia('(min-width: 768px)');

const init = () => {
  const els = document.querySelectorAll(selectors.el);

  const pointer = { x: 0, y: 0, t: performance.now(), vx: 0, vy: 0 };
  window.addEventListener('mousemove', e => {
    const now = performance.now();
    const dt = Math.max(1, now - pointer.t) / 1000;
    pointer.vx = (e.clientX - pointer.x) / dt;
    pointer.vy = (e.clientY - pointer.y) / dt;
    pointer.x = e.clientX;
    pointer.y = e.clientY;
    pointer.t = now;
  }, { passive: true });

  els.forEach(el => {
    el.classList.add('is-initialized');
  
    const onEnter = e => {
      if (!mq.matches) return;

      let vx = pointer.vx || 0;
      let vy = pointer.vy || 0;

      if (Math.hypot(vx, vy) < 50) {
        const rect = el.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        vx = (e.clientX - centerX) * 6;
        vy = (e.clientY - centerY) * 6;
      }

      const intensity = 0.12;
      const maxPush = 1000;
      vx = Math.max(-maxPush, Math.min(maxPush, vx * intensity));
      vy = Math.max(-maxPush, Math.min(maxPush, vy * intensity));

      gsap.killTweensOf(el);

      const pushFactor = 0.12;
      const targetX = vx * pushFactor;
      const targetY = vy * pushFactor;
      const speed = Math.hypot(vx, vy);
      const duration = Math.max(1.4, Math.min(2.4, speed / 1500));

      const hitDur = Math.max(.36, duration * 0.35);
      const returnDur = Math.max(.9, duration * 0.9);
      const overlap = Math.min(hitDur * 0.6, 0.25);

      const tl = gsap.timeline();
      tl.to(el, {
        duration: hitDur,
        x: targetX,
        y: targetY,
        ease: 'power2.out'
      }).to(el, {
        duration: returnDur,
        x: 0,
        y: 0,
        ease: 'elastic.out(1, 0.5)'
      }, `-=${overlap}`);
    };

    el.addEventListener('mouseenter', onEnter);
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
